import { InformationAlertIcon } from "@/assets/images/svgIcons/informationAlertIcon"
import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { word } from "@modules/core/utils/i18n"
import { useFinanceSidebar } from "@modules/finances/hooks/useFinanceSidebar"

type FinanceFeesAlertCardProps = {
  className?: string
  badge?: React.ReactNode
} & React.ComponentProps<"div">

export function FinanceFeesAlertCard({ className, badge, ...props }: FinanceFeesAlertCardProps) {
  const { navigateToFinanceFeesLayout } = useFinanceSidebar()

  return (
    <div
      className={cn(
        "relative flex flex-row items-center gap-4 overflow-hidden rounded-3xl bg-linear-96 from-surface-background-primary-information-secondary to-surface-background-primary-information-default px-6 py-4 before:absolute before:top-0 before:left-0 before:h-full before:w-1.5 before:bg-surface-background-primary-default",
        className,
      )}
      {...props}
    >
      <div className="flex shrink-0 items-start self-start pt-4">
        <InformationAlertIcon
          backgroundColor={"var(--surface-background-primary-default)"}
          color={"var(--color-interactive-text-primary-default)"}
        />
      </div>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col">
          <div className="flex flex-row items-center gap-1">
            <Text fontStyle="TM" className="text-textOnSurface-default">
              {word("finance.fees.alertCard.title")}
            </Text>
            {badge}
          </div>
          <Text fontStyle="BM" className="text-textOnSurface-default">
            {word("finance.fees.alertCard.description")}
          </Text>
        </div>

        <Button variant="primary" size="md" className="w-fit" onClick={() => navigateToFinanceFeesLayout(true)}>
          {word("finance.fees.alertCard.button")}
        </Button>
      </div>
    </div>
  )
}
